// extracted by mini-css-extract-plugin
module.exports = {"tab":"AccountTabList_tab__wW0NX"};